module.exports = __webpack_public_path__ + "static/media/2@2x.30fcfe59.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/2@2x.png
// module id = 1474
// module chunks = 0